<template>
    <nav class="navbar">
        <div class="navbar-brand brand-small">
            <component
                :is="isStaff ? 'router-link' : 'a'"
                v-bind="isStaff ? { to: { name: 'dashboard' } } : { href: urlHome }"
            >
                <SaasIcon
                    :icon="logoIcon"
                    :width="logoWidth"
                    :height="logoHeight"
                    class="navbar__logo"
                />
            </component>
        </div>
        <div class="navbar-container">
            <slot name="search"></slot>
            <div class="navbar-content">
                <ConformityCheckListHeader v-if="showEInvoicingConformityCheckList" />

                <slot name="onboarding-screen"></slot>
                <NavMenu :menuItems="menuData.items" :hasNotification="menuData.hasNotification" />
                <div class="navbar__divider"></div>
                <NavProfilMenu :userData="userData" :urlsData="urlsData" :lang="lang" />
            </div>
        </div>
    </nav>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';
import NavProfilMenu from 'vcomponents/header/NavProfilMenu.vue';
import NavMenu from 'vcomponents/header/NavMenu.vue';
import ConformityCheckListHeader from 'vcomponents/eInvoicing/ConformityCheckListHeader/ConformityCheckListHeader.vue';
import Feature from 'Services/Feature';

import { createNamespacedHelpers } from 'vuex';
const userMapState = createNamespacedHelpers('user').mapState;
const { mapGetters: corpMapGetters } = createNamespacedHelpers('corp');

export default {
    components: {
        SaasIcon,
        NavProfilMenu,
        NavMenu,
        ConformityCheckListHeader,
    },
    props: {
        userData: {
            type: Object,
            required: true,
        },
        urlsData: {
            type: Object,
            required: true,
        },
        menuData: {
            type: Object,
            required: true,
        },
        lang: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isFullMenu: true,
        };
    },
    computed: {
        ...userMapState(['type', 'isAdmin']),
        ...corpMapGetters({
            companyInformationLocked: 'getCompanyInformationLocked',
        }),
        logoIcon() {
            return this.isFullMenu ? 'svgLogoSellsyText' : 'svgLogoSellsyCloud';
        },
        logoWidth() {
            return this.isFullMenu ? '122' : '36';
        },
        logoHeight() {
            return this.isFullMenu ? '30' : '26';
        },
        isStaff() {
            return this.type === 'staff';
        },
        urlHome() {
            return this.isStaff ? '/dashboard' : '/home';
        },
        showEInvoicingConformityCheckList() {
            if (!Feature.isEnabled('facturx-show-status')) {
                return false;
            }

            return this.isAdmin || this.companyInformationLocked;
        },
    },
    created() {
        EventBus.on('main-menu:on-size-changed', ({ isFullMenu }) => {
            this.isFullMenu = isFullMenu;
        });
    },
    destroyed() {
        EventBus.off('main-menu:on-size-changed');
    },
};
</script>

<style lang="scss" scoped>
.navbar {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    min-width: 1024px !important;
    min-height: 60px;

    &__logo {
        color: var(--colors-common-text-standard-on-color);
    }

    &-brand {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 180px;
        background-color: var(--colors-common-background-darkest-default);

        &.brand-small {
            width: 64px;
        }

        a {
            display: block;
        }
    }

    &-container {
        position: relative;
        display: flex;
        flex-flow: row-reverse wrap;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        background-color: var(--colors-common-background-default);
        box-shadow: var(--box-shadows-x-small);

        .navbar-content {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            margin: 0 var(--spacing-4) 0 0;

            @media screen and (width < 1140px) {
                margin: 0 var(--spacing-3) 0 0;
            }

            &__divider {
                width: 1px;
                height: 32px;
                margin: 0 var(--spacing-2);
                background-color: var(--colors-common-border-lighter);
            }
        }
    }

    &__divider {
        width: 1px;
        height: 16px;
        background-color: var(--colors-common-border-lighter);
        margin: 0 var(--spacing-3);
    }
}
</style>

<style lang="scss">
html > body div.global {
    min-width: 1024px !important;
}
</style>
